export default __webpack_public_path__ + "static/media/Thông-bao-56_BQL-Cang-ca.7bbdeebb.pdf";